import { FC } from 'react'
import { FormGroup, Radio, RadioItem } from '@agro-club/agroclub-shared'
import { endpoints } from 'modules/endpoints'
import { useTranslation } from 'react-i18next'
import FormSelectShared from 'views/components/FormSelectShared'
import { SharedModalInputs } from 'views/components/SharedModal'
import { removeSeconds } from 'views/pages/LogisticsKR/helpers'
import { CommonUnloadWHForm } from 'views/pages/LogisticsKR/components/CommonUnloadWHForm'
import { FormItemWrapper } from 'views/styled/common'
import { FormikFieldsType } from 'modules/domain/types'

interface Props {
  formik: FormikFieldsType
  isNewAddress: boolean
  setIsNewAddress: (value: boolean) => void
}

export const UnloadingParameters: FC<Props> = ({ formik, isNewAddress, setIsNewAddress }) => {
  const { t } = useTranslation('logisticsKR')

  const handleAddressOptionLoad = (warehouse) => {
    if (!warehouse) return

    const {
      address,
      latitude,
      longitude,
      vehicle_type,
      is_dump_truck,
      unloading_type,
      volume_per_day,
      schedule_from,
      schedule_to,
      works_on_weekend,
      car_delivery,
      railway_delivery,
    } = warehouse.dto

    formik.setFieldValue('unloading_warehouse_address', address)
    formik.setFieldValue('unloading_warehouse_latitude', latitude)
    formik.setFieldValue('unloading_warehouse_longitude', longitude)
    formik.setFieldValue('unloading_warehouse_vehicle_type', vehicle_type)
    formik.setFieldValue('unloading_warehouse_is_dump_truck', is_dump_truck)
    formik.setFieldValue('unloading_warehouse_unloading_type', unloading_type)
    formik.setFieldValue('unloading_warehouse_volume_per_day', volume_per_day)
    formik.setFieldValue('unloading_warehouse_schedule_from', removeSeconds(schedule_from))
    formik.setFieldValue('unloading_warehouse_schedule_to', removeSeconds(schedule_to))
    formik.setFieldValue('unloading_warehouse_works_on_weekend', works_on_weekend)
    formik.setFieldValue('unloading_warehouse_car_delivery', car_delivery)
    formik.setFieldValue('unloading_warehouse_railway_delivery', railway_delivery)
  }

  /*   const handleNewAddress = (value) => {
    if (!value) return

    const { address, coords, geoObject } = value
    const [latitude, longitude] = coords

    formik.setFieldValue('unloading_warehouse_id', null)
    formik.setFieldValue('unloading_warehouse_address', address)
    formik.setFieldValue('unloading_warehouse_latitude', latitude)
    formik.setFieldValue('unloading_warehouse_longitude', longitude)
    formik.setFieldValue('unloading_warehouse_geo_object', geoObject)
  } */

  return (
    <SharedModalInputs>
      <FormGroup label={t('list.createForm.labels.systemAddress')}>
        <FormItemWrapper>
          <Radio onChange={(value) => setIsNewAddress(!!value)} value={isNewAddress ? 1 : 0}>
            <RadioItem value={0} label={t('list.createForm.labels.existing')} />
            <RadioItem value={1} label={t('list.createForm.labels.new')} />
          </Radio>
        </FormItemWrapper>
      </FormGroup>

      {isNewAddress ? (
        <FormGroup
          error={formik.errors.unloading_warehouse_address}
          label={t('list.createForm.labels.address')}
          required
        >
          {/*           <YandexAddressForm
            apikey={REACT_APP_YA_MAPS_API_KEY}
            onChange={handleNewAddress}
            placeholder={t('list.createForm.placeholders.systemAddress')}
            initialSearch={formik.values.unloading_warehouse_address}
            initialCoords={[formik.values.unloading_warehouse_latitude, formik.values.unloading_warehouse_longitude]}
          /> */}
        </FormGroup>
      ) : (
        <FormSelectShared
          endpoint={endpoints.LogisticsKR.unloadingWarehouse()}
          fieldName="unloading_warehouse_id"
          placeholder={t('list.createForm.placeholders.address')}
          label={t('list.createForm.labels.address')}
          formik={formik}
          getLabel={(dto) => dto.address}
          onSelectedOptionLoaded={handleAddressOptionLoad}
          required
        />
      )}

      <CommonUnloadWHForm formik={formik} />
    </SharedModalInputs>
  )
}
